import React, { FC } from "react";
import { Box, BoxProps } from "@chakra-ui/react";

const Spacer: FC<BoxProps> = (props) => <Box flexGrow={1} {...props} />;

export default Spacer;
